import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

// add scss
import '@/assets/scss/bootstrap.scss';
import '@/assets/scss/basic.scss';

// add axios
import axios from 'axios';
import VueAxios from 'vue-axios';

// Global axios defaults
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.use(VueAxios, axios);

// add QRCode library
import VueQriously from 'vue-qriously';
Vue.use(VueQriously);

// add long click
import { longClickDirective } from 'vue-long-click';
const longClickInstance = longClickDirective({ delay: 400, interval: 0 });
Vue.directive('longclick', longClickInstance);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
